export default {
    methods: {
        tweakDatePickers() {
            const datePickers = Array.from(
                window.document.querySelectorAll('ui5-date-picker.simplified')
            );
            datePickers.forEach((datePicker) => {
                const interval = window.setInterval(() => {
                    if (datePicker.shadowRoot) {
                        window.clearInterval(interval);
                        const input =
                            datePicker.shadowRoot.querySelector('ui5-input');
                        input.style.maxWidth = '100%';
                        input.style.width = '100%';
                        input.style.minWidth = '100%';
                        input.style.borderRadius = '8px';
                        const icon = input.shadowRoot.querySelector(
                            '.ui5-input-icon-root'
                        );
                        icon.style.display = 'none';
                    }
                }, 100);
            });
        },
        tweakRadioButtons() {
            window.document
                .querySelectorAll('ui5-radiobutton')
                .forEach((rb) => {
                    const interval = window.setInterval(() => {
                        if (rb.shadowRoot) {
                            window.clearInterval(interval);
                            const svg =
                                rb.shadowRoot.querySelector('.ui5-radio-svg');
                            const innerCircle = svg.querySelector(
                                '.ui5-radio-svg-inner'
                            );
                            innerCircle.setAttribute('r', '35%');
                        }
                    }, 100);
                });
        },
        hideTableHeaders() {
            const tables = window.document.querySelectorAll(
                'ui5-table.no-header'
            );
            Array.from(tables).forEach((table) => {
                const interval = window.setInterval(() => {
                    if (table.shadowRoot) {
                        window.clearInterval(interval);
                        const thead = table.shadowRoot.querySelector('thead');
                        thead.style.display = 'none';
                    }
                }, 100);
            });
        },
        applyMinMax() {
            const inputs = window.document.querySelectorAll(
                'ui5-input[min],ui5-input[max]'
            );
            if (inputs.length) {
                inputs.forEach((input) => {
                    const interval = window.setInterval(() => {
                        if (
                            input.shadowRoot &&
                            input.shadowRoot.mode == 'open'
                        ) {
                            window.clearInterval(interval);
                            const innerInput =
                                input.shadowRoot.querySelector('input');
                            const min = input.getAttribute('min');
                            if (min !== null) {
                                innerInput.setAttribute('min', min);
                            }
                            const max = input.getAttribute('max');
                            if (max !== null) {
                                innerInput.setAttribute('max', max);
                            }
                            const step = input.getAttribute('step');
                            if (step !== null) {
                                innerInput.setAttribute('step', step);
                            }
                        }
                    }, 100);
                });
            }
        },
    },
    mounted() {
        this.tweakDatePickers();
        this.tweakRadioButtons();
        this.hideTableHeaders();
        this.applyMinMax();
    },
    updated() {
        this.tweakDatePickers();
        this.tweakRadioButtons();
        this.hideTableHeaders();
        this.applyMinMax();
    },
};
